import React from "react";
import styled from "styled-components";

import {
  Modal,
  ModalButton,
  ModalCancelButton,
  ModalFooter,
} from "../../../../components/common/Modal";
import { COLORS } from "../../../../constants";

interface RenameDashboardModalProps {
  visible: boolean;
  renameValue: string;
  isLoading: boolean;
  onRenameValueChange: (value: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

const RenameInput = styled.input`
  width: 100%;
  padding: 6px 8px;
  border: 2px solid ${COLORS.black15};
  border-radius: 4px;
  font-size: 14px;
  outline: none;

  &:focus {
    border-color: ${COLORS.coeblue4};
  }
`;

export const RenameDashboardModal: React.FC<RenameDashboardModalProps> = ({
  visible,
  renameValue,
  isLoading,
  onRenameValueChange,
  onConfirm,
  onCancel,
}) => (
  <Modal title="Rename dashboard" visible={visible} onClose={onCancel} width={480}>
    <RenameInput
      value={renameValue}
      onChange={e => onRenameValueChange(e.target.value)}
      onKeyDown={e => {
        if (e.key === "Enter") {
          onConfirm();
        }
      }}
      autoFocus
    />
    <ModalFooter>
      <ModalCancelButton onClick={onCancel}>Cancel</ModalCancelButton>
      <ModalButton onClick={onConfirm} disabled={!renameValue.trim() || isLoading}>
        Rename
      </ModalButton>
    </ModalFooter>
  </Modal>
);
